<template>
  <div id="app">
    <div id="loading-screen" v-if="loading">
      <img
        id="history-lab-logo"
        src="@/assets/history_lab_logo_white.png"
        alt="loading icon"
      />
    </div>
    <Navbar id="nav" />
    <router-view id="view" />
    <Footer id="footer" />
  </div>
</template>

<script>
import Navbar from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: { Navbar, Footer },
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    setTimeout(() => (this.loading = false), 2500);
  }
};
</script>

<style lang="scss">
#app {
  top: 0;
  overflow: hidden;
  min-height: 100vh;
  max-height: 100vh;
}

#nav {
  z-index: 1;
  position: relative;
  height: 3.25rem;
}

#view {
  position: relative;
  overflow: hidden;
  min-height: calc(100vh - 7rem - 24px);
  max-height: calc(100vh - 7rem - 24px);
}

#footer {
  z-index: 1;
  position: relative;
  bottom: 0;
  height: calc(3.75rem + 24px);
  padding: 6px 0 18px 0;
}

#loading-screen {
  position: fixed;
  padding: 0;
  margin: 0;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  background: $red-gradient;
  z-index: 2; /* Needs to be ahead of the nav */
  animation: changeOpacity 4s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in;
}

#history-lab-logo {
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

@keyframes changeOpacity {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
